/*!

 =========================================================
 * Vue Light Bootstrap Dashboard - v2.0.0 (Bootstrap 4)
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */

// Imports
import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import VueNativeNotification from "vue-native-notification";
import VueAnalytics from "vue-analytics";
import VueSocialSharing from "vue-social-sharing";
import VueI18n from "vue-i18n";
import lang from "./language/lang";
import LightBootstrap from "./light-bootstrap-main";
import routes from "./routes/routes";
import "./registerServiceWorker";

// Uses
Vue.use(VueSocialSharing);
Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(LightBootstrap);

Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true,
});
// Configs
Vue.config.productionTip = false; // Prevent the production tip on Vue startup.

const i18n = new VueI18n({
  locale: navigator.language,
  messages: lang, // set locale messages
});

const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "nav-item active",
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

var url = window.location.origin;
if (url.includes("whodrinks.com")) {
  Vue.use(VueAnalytics, {
    id: "UA-171065779-1",
    router,
  });
}

new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  i18n,
});
